import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';
import { type PdpSharedDetailShipsFrom_item$data } from './__generated__/PdpSharedDetailShipsFrom_item.graphql.ts';

// styles
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    item: PdpSharedDetailShipsFrom_item$data;
};

const PdpSharedDetailShipsFromComponent: FC<Props> = props => {
    const itemAddress = props?.item?.address?.itemAddress;

    const itemAddressElement = <span className={dibsCss.sassyFontBody}>{itemAddress}</span>;

    return itemAddress ? (
        <div className={classnames(dibsCss.flex, dibsCss.mtXsmall)}>
            <span className={dibsCss.sassyFontBodyTypeHeavy}>
                <FormattedMessage
                    id="pdp.pdpShippingDetails.shipsFrom"
                    defaultMessage="Shipping from: {itemAddressElement}"
                    values={{ itemAddressElement }}
                />
            </span>
        </div>
    ) : null;
};

export const PdpSharedDetailShipsFrom = createFragmentContainer(PdpSharedDetailShipsFromComponent, {
    item: graphql`
        fragment PdpSharedDetailShipsFrom_item on Item {
            address {
                itemAddress: displayCityStateCountry(fullCountryName: true)
            }
        }
    `,
});
